import React from 'react'
import { Divider } from '@mui/material'
import { IBundlePlans } from 'types/api/v1/bundle.type'

import BundlePlanOptions from './BundlePlanOptions'
import ChooseSimQuantity from './ChooseSimQuantity'

interface PlanProps {
  bundleData: IBundlePlans[]
  setSelection: (value: number) => void
  selectedIndexPlan: number
  setValue: (value: number) => void
  value: number
  setSimsQuantity: (value: number | Array<number>) => void
  simsQuantity: number | Array<number>
  setSelectedBundlePlan: (value: IBundlePlans) => void
  discountAmount: number
}

function SelectPlan({
  bundleData,
  setSelection,
  selectedIndexPlan,
  setValue,
  value,
  setSimsQuantity,
  simsQuantity,
  setSelectedBundlePlan,
  discountAmount
}: PlanProps) {
  return (
    <>
      <BundlePlanOptions
        bundleData={bundleData}
        setValue={setValue}
        setSelectedBundlePlan={setSelectedBundlePlan}
        setSelection={setSelection}
        selectedIndexPlan={selectedIndexPlan}
        discountAmount={discountAmount}
        value={value}
      />
      <Divider sx={{ width: '95%', margin: '24px auto 8px' }} />
      <ChooseSimQuantity
        simsQuantity={simsQuantity}
        setSimsQuantity={setSimsQuantity}
      />
    </>
  )
}

export default SelectPlan
